export default __webpack_public_path__ + "static/media/content-image_gbr-map.ca749e75.png";